import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ButtonBase } from '@material-ui/core';
import Grid from '@mui/material/Grid';
import { firebaseAuth } from '../provider/AuthProvider';
import { chapterLink, chapterPath } from '../routing/chapterNavigation';
import SingleCard from './singleCard';

export default function ChapterCards({ entries = [] }) {
  const { token, paymentFlag } = useContext(firebaseAuth);
  const location = useLocation();
  return <Grid container spacing={2}>{entries.filter(chapter => chapter.active === 1 && chapterPath(chapter.id)).map(chapter => <Grid key={chapter.id} item>
    <ButtonBase component={Link} to={chapterLink(chapter.id, location)} aria-label={`Open chapter: ${chapter.name || chapter.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
      <SingleCard linked title={chapter.name} image={chapter.image} video={chapter.video} description={chapter.description} level={chapter.level} token={token} paymentFlag={paymentFlag} />
    </ButtonBase>
  </Grid>)}</Grid>;
}
